/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDeleteUserOptions, AdminDeleteUserResponses } from '../../models/AdminDeleteUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete User
 * {@link /admin/users/:user_id}
 */
export function adminDeleteUser<ThrowOnError extends boolean = true>(options: Options<AdminDeleteUserOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDeleteUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/users/{user_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDeleteUserResponses, ThrowOnError>>
}
